<div class="view-container">
  <div class="manufacturers">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Companies</label>
          <button 
            mat-flat-button type="button"
            color="accent"
            (click)="onClickAddCompany()"
            matTooltip="Add Company">
            <mat-icon>add</mat-icon>Add Company
          </button>
        </div>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
              <mat-form-field class="accent">
                <mat-label>Search companies by name</mat-label>
                <input matInput type="text"
                  [(ngModel)]="searchTerm"
                  (keyup.enter)="filterData()"
                  (keyup.esc)="searchTerm=''; filterData()"
                  name="searchTerm"
                  placeholder="Search Name">
                <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; filterData()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <div fxLayout="row" fxLayoutGap="10px">
                <button
                  type="submit"
                  mat-flat-button color="primary"
                  (click)="filterData()"
                  matTooltip="Search"
                  [class.button-spinner]="loading"
                  [disabled]="loading">
                  <mat-icon>search</mat-icon> Search
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <ng-container *ngFor="let item of filteredCompanies; let i = index;">
          <mat-card class="contrast" *ngIf="i < pageLength"
            [class.banner-error]="item?.disabled"
            [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
            <mat-card-content fxLayout="row" fxLayoutAlign="space-between center" fxLayout.lt-sm="column"  fxLayoutAlign.lt-sm="start center">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxLayout.lt-sm="column"  fxLayoutAlign.lt-sm="start center">
                <img fxHide.sm class="product-company-logo" *ngIf="getCompanyLogo(item?.id)" [lazyLoad]="getCompanyLogo(item?.id)">
                <div fxLayout="column" fxLayoutAlign="center start" fxLayoutAlign.lt-sm="center center">
                  <span [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | highlight: searchTerm" [matTooltip]="item?.id"></span>
                  <small class="text-info">{{ companyTypes[item.type] }}</small>
                </div>
                <div *ngIf="item?.parentCompanyId" fxHide.lt-sm><</div>
                <div *ngIf="item?.parentCompanyId" fxLayout="column" fxLayoutAlign="center start" fxLayoutAlign.lt-sm="center center">
                  <span [matTooltip]="item?.parentCompanyId">{{ getCompanyName(item?.parentCompanyId) }}</span>
                  <small class="text-info">Parent Company</small>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="end center" fxLayout.lt-sm="column" fxLayoutGap="10px">
                <div fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="2px">
                  <small>User count</small>
                  <small [class.text-info]="item.userCount !== 0"
                    [class.text-warning]="item.userCount === 0"
                    matTooltip="Users set up for this company">{{ item?.userCount }}</small>
                </div>
                <div fxLayout="row" fxLayoutAlign="end center">
                  <button mat-icon-button color="accent" aria-label="Edit Company" matTooltip="Edit Company" (click)="onEditManufacturer(item?.id)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    mat-icon-button color="primary"
                    aria-label="Preview Impression"
                    matTooltip="Preview Impression"
                    (click)="onViewCompany(item.id)">
                    <mat-icon>preview</mat-icon>
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </ng-container>
        <div #showMoreMarker fxLayout="row" fxLayoutAlign="center center">
          <mat-card *ngIf="hasMoreProductsToShow()" class="contrast card-link banner-info w-100" [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="showMoreProducts()">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
              <div fxFlex="100" fxLayoutAlign="center center" fxLayout="row">
                <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_more</mat-icon></strong>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
